"use strict";
// based on https://www.npmjs.com/package/fast-random?activeTab=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.fastRandoExt = void 0;
// License for this file
// MIT License
// Copyright (c) 2017 borilla
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var max = 2147483647;
var maxMinus1 = max - 1;
var magicPrimeNumber = 48271;
function fastRandoExt(originalSeed) {
    if (originalSeed === void 0) { originalSeed = 0; }
    var _currentSeed = _makeSeedInRange(originalSeed);
    var _originalSeed = _currentSeed;
    var _numRolls = 0;
    function _makeSeedInRange(newSeed) {
        if (newSeed === void 0) { newSeed = 0; }
        newSeed = (newSeed | 0) % max;
        if (newSeed <= 0) {
            newSeed += maxMinus1;
        }
        return newSeed;
    }
    function _nextInt() {
        _numRolls++;
        _currentSeed = (_currentSeed * magicPrimeNumber) % max;
        return _currentSeed;
    }
    function _nextFloat() {
        var val = _nextInt();
        return (val - 1) / maxMinus1; // Always a bit less than 1
    }
    return {
        setSeed: function (newSeed) {
            originalSeed = _currentSeed = _makeSeedInRange(newSeed);
        },
        getCurrentSeed: function () { return _currentSeed; },
        getOriginalSeed: function () { return _originalSeed; },
        getNumRolls: function () { return _numRolls; },
        nextInt: _nextInt,
        nextFloat: _nextFloat,
    };
}
exports.fastRandoExt = fastRandoExt;
